module.exports = __webpack_public_path__ + "static/media/arborea8.5e73539e.webp";